import React, { useState } from "react";
import axiosInstance from "../../Axios/axiosInstance";
import { Select, MenuItem } from "@mui/material";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Divider,
  Box,
  Snackbar,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

const EmployeeRegistration = () => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    dob: null,
    age: "",
    role: "",
    phoneno: "",
    joiningdate: null,
    address: "",
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [openSuccess, setOpenSuccess] = useState(false);

  const [errors, setErrors] = useState({
    email: false,
    phoneno: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Validation regex patterns
    const emailRegex = /^\S+@\S+\.\S+$/;
    const phoneRegex = /^[0-9]{10}$/;

    setFormData({
      ...formData,
      [name]: value,
    });
    // Exclude setting Date in handleChange
    if (name !== "dob") {
      setFormData({
        ...formData,
        [name]: value,
      });
      // Clear the specific error when the user starts typing in a field
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]:
          name === "email"
            ? !emailRegex.test(value)
            : name === "phoneno"
            ? !phoneRegex.test(value)
            : false,
      }));
    }

    if (name === "role") {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleDateChange = (date, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: date,
    });
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccess(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check required fields and set error state if empty
    const requiredFields = ["email", "phoneno"];
    let hasError = false;
    const updatedErrors = { ...errors };
    requiredFields.forEach((field) => {
      if (formData[field].trim() === "") {
        updatedErrors[field] = true;
        hasError = true;
      } else {
        updatedErrors[field] = false;
      }
    });

    if (hasError) {
      setErrors(updatedErrors);
      return;
    }

    try {
      const response = await axiosInstance.post(
        "/api/addEmployeeRegistration",
        {
          ...formData,
        }
      );

      if (response.status === 201) {
        setSuccessMessage("Form submitted successfully!");
        setOpenSuccess(true);

        // Hide the success message after 3 seconds (adjust duration as needed)
        setTimeout(() => {
          setOpenSuccess(false);
          setSuccessMessage("");
        }, 3000);

        setFormData({
          firstname: "",
          lastname: "",
          email: "",
          dob: null,
          age: "",
          role: "",
          phoneno: "",
          joiningdate: null,
          address: "",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          {/* Employee Registration Heading */}
          <Grid container item xs={12}>
            <Grid item xs={8}>
              <Typography variant="h5" align="left">
                User Registration
              </Typography>
            </Grid>
            <Grid item xs={4} className="text-end">
              <EditIcon />
            </Grid>
          </Grid>

          {/* Divider line */}
          <Grid item xs={12}>
            <Box>
              <Divider
                variant="fullWidth"
                style={{ backgroundColor: "black" }}
              />
            </Box>
          </Grid>

          {/* User Details */}
          <Grid item xs={12} className="">
            <Typography variant="h6" align="left">
              User Details
            </Typography>
          </Grid>

          {/* -----------input fields---------------------------------------- */}
          <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">First Name</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="firstname"
                  value={formData.firstname}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Last Name</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="lastname"
                  value={formData.lastname}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Date Of Birth */}
          <Grid item xs={12} lg={6} md={6} sm={12} className="">
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Date Of Birth</Typography>
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={formData.dob}
                    onChange={(date) => handleDateChange(date, "dob")}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Age</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="age"
                  value={formData.age}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Email Id</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  size="small"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  error={errors.email} // Show error style if true
                  helperText={errors.email ? "Email ID is required" : ""}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Phone Number</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="phoneno"
                  value={formData.phoneno}
                  size="small"
                  onChange={handleChange}
                  error={errors.phoneno} // Show error style if true
                  helperText={errors.phoneno ? "Phone Number is required" : ""}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Role</Typography>
              </Grid>
              <Grid item xs={6}>
                <Select
                  fullWidth
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                >
                  <MenuItem value="">Select Role</MenuItem>
                  <MenuItem value="admin">Admin</MenuItem>
                  <MenuItem value="user">User</MenuItem>
                  {/* Add more MenuItem components for other roles */}
                </Select>
              </Grid>
            </Grid>
          </Grid>

          {/* Joining Date */}
          <Grid item xs={12} lg={6} md={6} sm={12} className="">
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Joining Date</Typography>
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={formData.joiningdate}
                    onChange={(date) => handleDateChange(date, "joiningdate")}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={6} md={6} sm={12} className="">
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Address</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  size="small"
                  fullWidth
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Grid>
          {/* ----------- Submit Date ---------------------------------------- */}

          <Grid item xs={12} className="text-center mt-5">
            <Button variant="contained" color="primary" type="submit">
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
      {/* Success Snackbar */}
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={openSuccess}
        autoHideDuration={3000}
        onClose={handleSuccessClose}
        message={successMessage}
      />
    </>
  );
};

export default EmployeeRegistration;
